/* CardX Redesign – Live-Suche im Header (Shopify Predictive Search, ohne Bibliotheken) */
(() => {
  'use strict';

  const T = window.CXTheme;
  const input = document.querySelector('[data-cx-ps-input]');
  const box = document.querySelector('[data-cx-ps]');
  if (!T || !input || !box) return;

  const quick = document.querySelector('[data-cx-ps-quick]');
  const url = (window.CX && window.CX.routes && window.CX.routes.predictive) || '/search/suggest';
  const cache = new Map();
  let timer;
  let controller;
  let lastTerm = '';

  const show = (html) => {
    box.innerHTML = html;
    box.classList.toggle('is-filled', Boolean(html));
    if (quick) quick.hidden = Boolean(html);
    T.initMediaTone(box);
  };

  const load = async (term) => {
    if (cache.has(term)) {
      show(cache.get(term));
      return;
    }
    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;
    box.setAttribute('aria-busy', 'true');
    try {
      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'product,collection,page,query',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
        section_id: 'cx-predictive-search',
      });
      const res = await fetch(url + '?' + params.toString(), controller ? { signal: controller.signal } : {});
      if (!res.ok) throw new Error(String(res.status));
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const inner = doc.querySelector('#cx-ps-results');
      const html = inner ? inner.outerHTML : '';
      cache.set(term, html);
      if (term === lastTerm) show(html);
    } catch (e) {
      if (e.name !== 'AbortError') show('');
    } finally {
      box.removeAttribute('aria-busy');
    }
  };

  input.addEventListener('input', () => {
    const term = input.value.trim();
    lastTerm = term;
    clearTimeout(timer);
    if (term.length < 2) {
      show('');
      return;
    }
    timer = setTimeout(() => load(term), 220);
  });

  /* Pfeiltasten: vom Suchfeld durch die Treffer navigieren */
  const items = () => T.$$('[data-cx-ps-item]', box);
  input.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowDown' && items().length) {
      event.preventDefault();
      items()[0].focus();
    }
  });
  box.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    const list = items();
    const index = list.indexOf(document.activeElement);
    if (index === -1) return;
    event.preventDefault();
    if (event.key === 'ArrowDown') (list[index + 1] || list[index]).focus();
    else if (index === 0) input.focus();
    else list[index - 1].focus();
  });
})();